export default __webpack_public_path__ + "static/media/Impenetrable Legguards.f05ffb1a.jpg";